import { render, staticRenderFns } from "./ProjetosLista.vue?vue&type=template&id=97318bc2&scoped=true&"
import script from "./ProjetosLista.vue?vue&type=script&lang=js&"
export * from "./ProjetosLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97318bc2",
  null
  
)

export default component.exports